<template>
	<div>

		<v-toolbar flat fixed nopadding>
      		<v-toolbar-side-icon @click="fn_goBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
      		<v-toolbar-title>Connection Requests</v-toolbar-title>
      		<v-spacer></v-spacer>
      		<v-btn icon @click="fn_getToken" :disabled="loading"><v-icon>loop</v-icon></v-btn>

            <v-text-field clearable elevation-10  flat solo placeholder="Search..." v-model="searchValue" slot="extension" :class="{'bottom-shadow':scrollPositionTop!=0}"></v-text-field>
    	</v-toolbar>

	    <div class="hasToolbar hasExtension">
	    	
	    	<v-list three-line nopadding>
	    		
	    		<div v-for="(item, index) in filteredItems" :key="index">
	    			<v-list-tile>

	                    <v-list-tile-content>
	                        <v-list-tile-title>Connection ID: {{item.connectionNumber}}</v-list-tile-title>
                            <v-list-tile-sub-title>Requested by {{item.requestedByMe == "true" ? 'me' : item.userName}}</v-list-tile-sub-title>
                            <v-list-tile-sub-title>on {{item.requestTime | moment("hh:mm:ss a")}}</v-list-tile-sub-title>
	                    </v-list-tile-content>

	                    <v-list-tile-action>
	                    	<v-btn :disabled="loading" color="primary" @click="fn_getConnectionStatus(item)">Connect</v-btn>
			            </v-list-tile-action>

	                </v-list-tile>

	                <v-divider v-if="items.length-1!=index"></v-divider>

	    		</div>

	    	</v-list>

	    	<div v-if="!filteredItems.length" class="display_msg">There are no connection requests!</div>
	    </div>

	</div>
</template>

<script>

	export default{
		data(){
			return{
                loading:false,
				items:[],
                searchValue:'',
                scrollPositionTop:0,
			}
		},
		methods:{
			fn_goBack: function(){
				this.$router.go(-1);
			},

            // fn_getExpirationTime: function(startTime){
            //     let dateTimeNow = new Date();
            //     let requestTime = new Date(startTime);
            //     let expirationTime = requestTime.setMinutes(requestTime.getMinutes() + 2);
            //     if(expirationTime < dateTimeNow){
            //         return 0;
            //     }
            //     else{
            //         let timeDifference = expirationTime - dateTimeNow;
            //         let minutes = (timeDifference/60000).toString();
            //         let minutesSubstr = minutes.substr(minutes.indexOf('.')+1);
            //         let seconds = minutesSubstr[0] + minutesSubstr[1];
            //         return Math.round(minutes) + ':' + seconds;
            //     }
            // },

			fn_getToken: function(){
				self = this;
				this.showLoading("Please wait...");
                this.loading = true;
				this.$root.fn_getAuthToken(function(token){
                    if(token == 'error'){
                        self.hideLoading();
                        self.loading = false;
                        return;
                    }

                    if(self.$root.CurrentBusiness.temporaryBusiness){
                        self.fn_getMyBusinessID(token);
                    }
                    else{
                        self.fn_items(token);
                    }
                });
			},

            fn_getMyBusinessID: function(token){
                let self = this;
                this.getData('MainBusinessId', null, 
                    {
                    onSuccess: function(response){
                        console.log(response);
                        self.fn_items(token, response);
                    }, 
                    onError: function(error){
                        self.showToast('Something went wrong. Please try again.');
                        self.hideLoading();
                    }
                });
            },

			fn_items: function(token, myBusinessID){
				if(!navigator.onLine){
                    this.hideLoading();
                    this.loading = false;
	                this.showToast('Internet not available');
	                return;
	            }
	            
	            let self = this;
	            let dataObj = {};
	            dataObj.businessId = myBusinessID ? myBusinessID : this.$root.CurrentBusiness.BusinessID;
	            dataObj.token = token;
	            this.getServerData('GetConnectionRequests', dataObj, 
	                {
	                    onSuccess: function(response){
	                    	console.log(response);
	                    	self.items = JSON.parse(response);
	                        self.hideLoading();
                            self.loading = false;
	                    }, 
	                    onError: function(error){
	                        console.log(error);
	                        self.hideLoading();
                            self.loading = false;
	                        if(typeof JSON.parse(error) == 'object'){
	                            let response = JSON.parse(error);
	                            self.showToast(response.Message);
	                        }
	                    }, 
	                }
	            );
			},

            fn_getConnectionStatus: function(item){
                let self = this;
                this.showLoading('Please wait...');
                this.getData('ConnectionStatus', item.connectionid, 
                    {
                    onSuccess: function(response){
                        console.log(response);
                        if(response==0){
                            self.fn_sendConnectionRequest(item);
                        }
                        else if(response==1){
                            // self.showToast('Connecting...');
                            // self.hideLoading();
                            // self.fn_goBack();
                            self.fn_sendConnectionRequest(item);
                        }
                        else if(response==2){
                            self.showToast('Connected');
                            self.hideLoading();
                            self.fn_goBack();
                        }
                    }, 
                    onError: function(error){
                        self.showToast('Something went wrong. Please try again.');
                        self.hideLoading();
                        console.log(error);
                    }
                });
            },

            fn_sendConnectionRequest: function(item){
				if(!navigator.onLine){
	                this.showToast('Internet not available');
                    this.hideLoading();
	                return;
	            }

                let dateTimeNow = new Date().getTime();
                let requestTime = new Date(item.requestTime);
                let expirationTime = requestTime.setMinutes(requestTime.getMinutes() + 2);
                if(expirationTime < dateTimeNow){
                    this.showToast('This connection request has been expired!');
                    this.hideLoading();
                    this.fn_getToken();
                    return;
                }
	            
	            let self = this;
	            let filterObj = {};
	            filterObj.businessId = item.businessid;
                filterObj.connectionId = item.connectionid;
                this.loading = true;

                // this.showLoading('Please wait...');
                this.showToast('Connecting...');
                setTimeout(() => {
                    this.hideLoading();
                    this.fn_goBack();
                }, 5000);
	            this.getFilterData('PushLocalConnectionRequest', null, filterObj, 
	                {
	                    onSuccess: function(response){
	                    	console.log(response);
	                    	self.loading = false;
	                    }, 
	                    onError: function(error){
	                        console.log(error);
                            self.loading = false;
	                    }, 
	                }
	            );
			},

			
		},

	  	mounted: function(){
	  		window.js_globals.fn_onBackPress = this.fn_goBack;
	  		this.fn_getToken();
	  	},
        computed:{
            filteredItems: function () {
                let searchText = this.searchValue ? this.searchValue.toLowerCase() : '';

                return this.items.filter(item => {
                    let connectionNumber = item.connectionNumber.toLowerCase();
                    return connectionNumber.match(searchText);
                })
            }
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/settings/connection_requests/items.vue